var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-wrapper"},[_c('div',{staticClass:"content-box"},[_c('a-dropdown',[_c('span',{staticClass:"action ant-dropdown-link user-dropdown-menu"},[_c('span',[_vm._v(_vm._s(_vm.nickname()))])])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }